import { render } from "./Integration_WhatsappMessage_Dialog.vue?vue&type=template&id=207c703e&scoped=true&ts=true"
import script from "./Integration_WhatsappMessage_Dialog.vue?vue&type=script&lang=ts"
export * from "./Integration_WhatsappMessage_Dialog.vue?vue&type=script&lang=ts"

import "./Integration_WhatsappMessage_Dialog.vue?vue&type=style&index=0&id=207c703e&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207c703e"]])

export default __exports__